import Constants from '@/Constants';
import { Highlight } from '@/models/Highlight';
import http from '@/services/HttpService';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { highlightsFailure, highlightsSuccess, sendHighlightFailure, sendHighlightSuccess } from './actions';
import { HighlightsRequest, HighlightTypes } from './types';

export function* highlightsRequest(action: PayloadAction<HighlightTypes.HIGHLIGHTS_REQUEST, HighlightsRequest>) {
    try {
        const { data } = action.payload;
        const queryParams = `?contentId=${data.contentId}&contentType=${data.contentType}&offset=${data.offset}&limit=${data.limit}`;
        const response: AxiosResponse = yield call(http.get, Constants.CAST_HIGHLIGHT_URI + queryParams);
        const { total } = response.headers;
        yield put(highlightsSuccess({ data: response.data, listSize: total, resetData: action.payload.resetData }));
    } catch (error) {
        yield put(highlightsFailure());
    }
}

export function* sendHighlightRequest(action: PayloadAction<HighlightTypes.SEND_HIGHLIGHT_REQUEST, Highlight>) {
    try {
        const { data } = yield call(http.post, Constants.SOCIAL_HIGHLIGHT_URI, action.payload);
        action.payload.externalPersonId = data?.externalPerson?.id;
        yield put(sendHighlightSuccess(action.payload));

        yield call(highlightsRequest, {
            type: HighlightTypes.HIGHLIGHTS_REQUEST,
            payload: {
                data: {
                    offset: 0,
                    limit: Constants.COMMENTS_PAGINATION_LIMIT,
                    contentId: action.payload.content.id,
                    contentType: action.payload.content.type,
                },
                resetData: true,
            } as HighlightsRequest,
        });
    } catch (error) {
        yield put(sendHighlightFailure());
    }
}
